export default __webpack_public_path__ + "static/customer-service-management_attribution_dark-3e8a8f362f12df3cb280df2ee2af9fb9.svg";